import { jsx as t } from "react/jsx-runtime";
import { useBreakpointValue as s, useMultiStyleConfig as n, SimpleGrid as r, Flex as i } from "@chakra-ui/react";
const m = ({
  children: o,
  __TYPE: p,
  ...l
}) => {
  const a = s({ base: !0, md: !1 }, { fallback: "md" }), e = {
    role: "list",
    "aria-label": "SGI links",
    sx: n("GlobalFooter").mainLinksContainer
  };
  return a ? /* @__PURE__ */ t(r, { ...e, columns: 2, rowGap: 2, columnGap: 4, ...l, children: o }) : /* @__PURE__ */ t(
    i,
    {
      ...e,
      flexWrap: "wrap",
      justifyContent: "flex-start",
      flexDirection: "row",
      gap: 4,
      ...l,
      children: o
    }
  );
};
m.defaultProps = {
  __TYPE: "GlobalFooterMainLinks"
};
export {
  m as GlobalFooterMainLinks
};
